import React, { useEffect, useState } from "react";
import Organization from "../Image/Oraganization.png";
import $ from "jquery";
import { useDispatch, useSelector } from "react-redux";
import { Ask_Question, Show_Message } from "../General/Messagedialogbox";
import { API_POST, API_PUT } from "../General/Utility";
import {
  ShowHide_Popup,
  Update_POStemplate,
} from "../features/Transactionstates";

const pad2 = (num) => num.toString().padStart(2, "0");

export default function Posrightmenu() {
  const [dCashout, setdCashout] = useState((0).toFixed(2));
  const [dCashIn, setdCashIn] = useState((0).toFixed(2));
  const [strOutReason, setstrOutReason] = useState("");
  const [strInReason, setstrInReason] = useState("");
  const [Timer, setTimer] = useState("");
  const [isBusy, setisBusy] = useState(false);

  const dispatch = useDispatch();
  const _AuthParems = useSelector((state) => state.Common.Admin);
  const _Common = useSelector((store) => store.Transstates.Common);
  const _Employee = useSelector((store) => store.Transstates.Employee);

  // ✅ FIX: Escape listener was added on every open and never removed (leak).
  // Escape now also really closes the panel (it only removed a CSS class before).
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        Close_Menu();
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  // ✅ FIX: setInterval was never cleared -> one more timer stacked up every time
  // the menu was opened (leak + setState on an unmounted component all day long).
  // Also shows nothing instead of "NaN:NaN:NaN:NaN" when no session / bad date.
  useEffect(() => {
    const tick = () => {
      if (Number(_Common.iSessionId) === 0) {
        setTimer("");
        return;
      }
      const total =
        Date.now() - new Date(_Common.TDateTime + " " + _Common.TStartTime).getTime();
      if (isNaN(total) || total < 0) {
        setTimer("");
        return;
      }
      const ss = Math.floor((total / 1000) % 60);
      const mm = Math.floor((total / 1000 / 60) % 60);
      const hr = Math.floor((total / 1000 / 60 / 60) % 24);
      const d = Math.floor(total / 1000 / 60 / 60 / 24);
      setTimer(`${pad2(d)}:${pad2(hr)}:${pad2(mm)}:${pad2(ss)}`);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [_Common.TDateTime, _Common.TStartTime, _Common.iSessionId]);

  const Close_Menu = () => {
    $("#pos-menu").removeClass("active");
    dispatch(ShowHide_Popup("IsRightMenu"));
  };
  const Do_Logout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/";
  };
  // ✅ FIX: Sign Out wiped storage immediately (no confirmation, bill lost).
  const LogoutClick = () => {
    Ask_Question(dispatch, Do_Logout, "Do you want to sign out?", true);
  };
  const Clear_Click = () => {
    setdCashout((0).toFixed(2)); // was set to number 0 -> input showed "0" not "0.00"
    setdCashIn((0).toFixed(2));
    setstrInReason("");
    setstrOutReason("");
  };

  // Cash In / Cash Out share one validated routine (they were two copies).
  const Post_Cash = async (isCashIn) => {
    if (isBusy) return;
    const label = isCashIn ? "Cash In" : "Cash Out";
    const amount = Number(isCashIn ? dCashIn : dCashout);
    const reason = (isCashIn ? strInReason : strOutReason).trim();
    const sessionId = Number(_AuthParems.Session || localStorage.Session);
    if (!sessionId) {
      Show_Message(dispatch, "Please start a session first", "info");
      return;
    }
    if (!(amount > 0)) {
      Show_Message(dispatch, `Please enter a valid ${label} amount`, "info");
      return;
    }
    if (!isCashIn && reason.length === 0) {
      Show_Message(dispatch, "Please enter the Cash Out reason", "info");
      return;
    }
    try {
      setisBusy(true);
      const objEntSession = {
        TransId: 0,
        SessionId: sessionId,
        CashOut: isCashIn ? 0 : Number(amount.toFixed(2)),
        CashIn: isCashIn ? Number(amount.toFixed(2)) : 0,
        Remark: reason,
        EmpId: Number(_Employee.iEmpId),
        iUserId: Number(_AuthParems.User),
        strDBName: _AuthParems.DB,
        isCashIn: isCashIn,
      };
      const res = await API_POST(`POS/InsUpd_CashOut`, objEntSession, dispatch);
      if (res) {
        Show_Message(dispatch, res.strMessage, "success");
        Clear_Click();
      }
    } catch (err) {
      Show_Message(dispatch, err.message, "error");
    } finally {
      setisBusy(false);
    }
  };

  const Update_Template = async () => {
    const prevMode = !!_Common.IsTabletMode;
    try {
      dispatch(Update_POStemplate(!prevMode));
      // API_PUT never throws: on failure it shows the message and returns undefined
      const res = await API_PUT(
        `POS/Update_Template/${Number(!prevMode)}/${Number(_Common.iSessionId)}/${
          _AuthParems.DB
        }`,
        dispatch
      );
      if (!res) dispatch(Update_POStemplate(prevMode)); // server refused -> put the toggle back
    } catch (err) {
      dispatch(Update_POStemplate(prevMode));
      Show_Message(dispatch, err.message, "error");
    }
  };

  // ✅ FIX: panel used to close the moment the mouse left it, even while the
  // cashier was typing an amount (typed values were lost). Now it stays open
  // while a field inside it has focus.
  const MouseLeave = (e) => {
    const el = document.activeElement;
    if (
      el &&
      e.currentTarget.contains(el) &&
      (el.tagName === "INPUT" || el.tagName === "TEXTAREA")
    )
      return;
    dispatch(ShowHide_Popup("IsRightMenu"));
  };

  return (
    <div id="pos-menu" onMouseLeave={MouseLeave}>
      <div className="companyname">
        <img src={Organization} alt="Company Name"></img>
        <div>{_AuthParems.Branchname}</div>
        {_AuthParems.Logo && (
          <div id="cmplogo">
            <img className="logo" src={_AuthParems.Logo} alt="Company Logo" />
          </div>
        )}
      </div>
      <ul>
        <li className="cash-out">
          <label>Cash In</label>
          <input
            type="number"
            min="0"
            step="0.01"
            className="form-control mt-2"
            value={dCashIn}
            onChange={(e) => setdCashIn(e.target.value)}
            onBlur={(e) => setdCashIn((Number(e.target.value) || 0).toFixed(2))}
            onClick={(e) => e.target.select()}
            onKeyDown={(e) => {
              if (e.key === "Enter") Post_Cash(true);
            }}
          />
          <input
            type="text"
            className="form-control mt-2"
            value={strInReason}
            onChange={(e) => setstrInReason(e.target.value)}
            placeholder="Cash In Reason"
            onClick={(e) => e.target.select()}
            onKeyDown={(e) => {
              if (e.key === "Enter") Post_Cash(true);
            }}
          />
        </li>
        <li className="mt-1">
          <button
            onClick={(e) => Post_Cash(true)}
            className="mbtn"
            disabled={isBusy}
          >
            <i className="fa-solid fa-indian-rupee-sign"></i>
            Add Cash In
          </button>
        </li>
        <li className="cash-out">
          <label>Cash Out</label>
          <input
            type="number"
            min="0"
            step="0.01"
            className="form-control mt-2"
            value={dCashout}
            onChange={(e) => setdCashout(e.target.value)}
            onBlur={(e) => setdCashout((Number(e.target.value) || 0).toFixed(2))}
            onClick={(e) => e.target.select()}
            onKeyDown={(e) => {
              if (e.key === "Enter") Post_Cash(false);
            }}
          />
          <input
            type="text"
            className="form-control mt-2"
            value={strOutReason}
            onChange={(e) => setstrOutReason(e.target.value)}
            placeholder="Cash Out Reason"
            onClick={(e) => e.target.select()}
            onKeyDown={(e) => {
              if (e.key === "Enter") Post_Cash(false);
            }}
          />
        </li>
        <li className="mt-1">
          <button
            onClick={(e) => Post_Cash(false)}
            className="mbtn"
            disabled={isBusy}
          >
            <i className="fa-solid fa-indian-rupee-sign"></i>
            Add Cash Out
          </button>
        </li>
        <li className="mt-1">
          <button
            onClick={(e) => dispatch(ShowHide_Popup("IsSession"))}
            className="mbtn"
          >
            <i className="fa-regular fa-clock"></i>
            {Number(_Common.iSessionId) === 0
              ? "Start Session"
              : "End Session "}
            <span style={{ fontSize: "12px", color: "blueviolet" }}>
              {Timer}
            </span>
          </button>
        </li>
        <li className="touch-btn">
          <label>Screen Template</label>
          <label className="switch-touch " onClick={() => Update_Template()}>
            <div
              className={_Common.IsTabletMode ? "toggle active" : "toggle"}
            ></div>
            <span className="pc">PC Screen</span>
            <span className="mobile">Mobile Screen</span>
          </label>
        </li>
        <li>
          <button onClick={(e) => LogoutClick()} className="mbtn mt-2">
            <i className="fa-solid fa-power-off"></i> Sign Out
          </button>
        </li>
        <li className="pos-help">
          <label>Shortcut Keys</label>
          <label>(F1) - Load and Search Product</label>
          <label>(F2) - Select Customer or Add New Customer</label>
          <label>(F3) - Session Open Close</label>
          <label>(F4) - Payment Mode (cycle)</label>
          <label>(F5) - Go to Item List (Up/Down, Enter = Edit, Del = Remove)</label>
          <label>(F6) - View Invoice</label>
          <label>(F8) - Discount</label>
          <label>(F9) - Add Notes</label>
          <label>(Ctrl+S) - Save Invoice</label>
          <label>(Ctrl+E) - Clear Invoice</label>
          <label>(Esc) - Close this menu</label>
        </li>
      </ul>
    </div>
  );
}